import React, { useState, useContext } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HiOutlineMenuAlt2, HiOutlineX } from "react-icons/hi";

import base from '../assets/images/header_base.png';

import header from '../assets/images/header.jpg';
import header_en from '../assets/images/header_en.jpg';

import br from '../assets/images/br.png';
import en from '../assets/images/en.png';

import LanguageContext from '../contexts/language';
import AuthContext from '../contexts/auth';

export default function Header() {

    const { signed } = useContext(AuthContext);
    const { language, setLanguageStore } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    function setLanguage(lang) {
        setLanguageStore(lang);
    }

    const [menu, setMenu] = useState('close');

    const location = useLocation();
    const isSubInscricaoPaths = [
        '/inscricao',
    ];
    const isSubPressPaths = [
        '/imprensa',
        '/materias',
        '/inscricao-imprensa'
    ];

    const isSubPanelPaths = [
        '/painelistas?dia=26',
        '/painelistas?dia=27'
    ];
      
    const isSubInscricao = isSubInscricaoPaths.some(path =>
        location.pathname.startsWith(path)
    );

    const isSubPress = isSubPressPaths.some(path =>
        location.pathname.startsWith(path)
    );

    const isSubPanel = isSubPanelPaths.some(path =>
        (location.pathname + location.search).startsWith(path)
    );

    function MyNavLink({ to, children, className }) {
        const location = useLocation();
        const isActive = (location.pathname + location.search) === to;
      
        return (
            <Link to={to} className={isActive ? `${className} active` : className} onClick={() => setMenu('close')}>
                {children}
            </Link>
        );
    }

    return (
        <div className="header-menu">
            <div className="header">
                <Link to="/">
                    <img src={lang==='pt' ? header : header_en} className="bg-cover"/>
                </Link>
            </div>
            <Navbar>
                <Container fluid>
                    <div className="menu-mobile" onClick={() => setMenu('open')}>
                        <HiOutlineMenuAlt2 />
                        <NavLink to="/assistir" className="nav-link nav-login">{language.menu_watch}</NavLink>
                    </div>
                    <div className="menu-content-desktop">
                        <Navbar.Collapse>
                            <Nav>
                                <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_home}</NavLink>
                                <NavLink to="/sobre" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_about}</NavLink>
                                <NavLink to="/agenda" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_agenda}</NavLink>
                                <NavLink to="/painelistas" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_panel}</NavLink>
                                <NavLink to="/imprensa" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_imprensa}</NavLink>
                                <NavLink to="/local-evento" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_local}</NavLink>
                                <NavLink to="/assistir" className="nav-link nav-login">{language.menu_watch}</NavLink>
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                    <NavDropdown title={<>
                            <img src={lang==='pt' ? br : en} />
                            <span>{language.language_active }</span>
                        </>} menuVariant="light">
                        <NavDropdown.Item onClick={() => {setLanguage('pt')}}>{language.language_pt_inverse}</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {setLanguage('en')}}>{language.language_en_inverse}</NavDropdown.Item>
                    </NavDropdown>
                </Container>
            </Navbar>
            <div className={`menu-content ${menu}`}>
                <div className="menu-mobile-close" onClick={() => setMenu('close')}>
                    <HiOutlineX />
                </div>
                <Navbar>
                    <Nav>
                        <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_home}</NavLink>
                        {/* <div className="has-submenu">
                            <a className={`nav-link ${isSubInscricao ? 'active' : ''}`}>{language.menu_inscricao}</a>
                            <div className="submenu">
                                <NavLink to="/inscricao" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sub_inscricao}</NavLink>
                                <NavLink to="/inscricao-imprensa" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sub_inscricao_imprensa}</NavLink>
                            </div>
                        </div> */}
                        {/* <NavLink to="/inscricao" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sub_inscricao}</NavLink> */}
                        <NavLink to="/sobre" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_about}</NavLink>
                        <NavLink to="/agenda" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_agenda}</NavLink>
                        <NavLink to="/painelistas" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_panel}</NavLink>
                        <NavLink to="/imprensa" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_imprensa}</NavLink>
                        <NavLink to="/local-evento" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_local}</NavLink>
                        <NavLink to="/assistir" className="nav-link nav-login">{language.menu_watch}</NavLink>
                    </Nav>
                </Navbar>
            </div>
        </div>
    );
}